package com.vizio.redwolf.auth.model

sealed class ApiFileLogResult {
    class Success : ApiFileLogResult()
    data class Failed(val response: FileLoggerFailureResponse) : ApiFileLogResult()
    data class Error(val exception: Throwable) : ApiFileLogResult()

    fun <R> fold (
        onSuccess: (Success: Success) -> R,
        onFailed: (Failed: Failed) -> R,
        onError: (Error: Error) -> R
    ) : R {
        return when (this) {
            is Success -> onSuccess(Success())
            is Failed -> onFailed(Failed(this.response))
            is Error -> onError(Error(this.exception))
        }
    }
}